import { render, staticRenderFns } from "./Marketmanagelist.vue?vue&type=template&id=f8b66fa2&scoped=true"
import script from "./Marketmanagelist.vue?vue&type=script&lang=js"
export * from "./Marketmanagelist.vue?vue&type=script&lang=js"
import style0 from "./Marketmanagelist.vue?vue&type=style&index=0&id=f8b66fa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8b66fa2",
  null
  
)

export default component.exports